import React from "react";

function StudentDetailsModal({ open, onClose, student }) {
  if (!open || !student) return null;

  const parentsByRelation = (relation) =>
    (student.parents || []).filter((p) => p.relation === relation);

  // Helpers
  const formatDate = (str) =>
    str ? new Date(str).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : '-';

  const calcAgeMonths = (dob) => {
    if (!dob) return '-';
    const birth = new Date(dob);
    const now = new Date();
    let months = (now.getFullYear() - birth.getFullYear()) * 12 + (now.getMonth() - birth.getMonth());
    if (now.getDate() < birth.getDate()) months--;
    return `${months} months`;
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg shadow-lg p-5 max-w-xl w-full max-h-[90vh] overflow-y-auto relative">
        <button onClick={onClose} className="absolute right-2 top-2 text-gray-400 hover:text-black text-2xl font-bold">&times;</button>
        <h2 className="text-2xl font-bold mb-2">Student Details</h2>

        {/* Basic Info */}
        <div className="mb-4">
          <div className="text-lg font-semibold mb-1">Basic Information</div>
          <div className="grid grid-cols-2 gap-2 text-sm">
            <div><span className="font-medium">First Name: </span>{student.first_name}</div>
            <div><span className="font-medium">Last Name: </span>{student.last_name}</div>
            <div><span className="font-medium">UCI: </span>{student.uci || '-'}</div>
            <div><span className="font-medium">Date of Birth: </span>{formatDate(student.dob)}</div>
            <div><span className="font-medium">Age: </span>{calcAgeMonths(student.dob)}</div>
            <div><span className="font-medium">Gender: </span>{student.gender || '-'}</div>
            <div><span className="font-medium">Start of Service: </span>{formatDate(student.service_start_date)}</div>
            <div><span className="font-medium">Onboarding Documents: </span>{student.onboarding_documents || '-'}</div>
          </div>
        </div>

        {/* Address Info */}
        <div className="mb-4">
          <div className="text-lg font-semibold mb-1">Address Information</div>
          <div className="text-sm">
            {student.address_street && <div><span className="font-medium">Street: </span>{student.address_street}</div>}
            {student.address_city && <div><span className="font-medium">City: </span>{student.address_city}</div>}
            {student.address_state && <div><span className="font-medium">State: </span>{student.address_state}</div>}
            {student.address_zip && <div><span className="font-medium">ZIP: </span>{student.address_zip}</div>}
			{student.notes && student.notes.trim() !== '' && (
			      <div className="mt-2">
			        <span className="font-medium">Address Notes:</span>
			        <span className="whitespace-pre-line ml-2">{student.notes}</span>
			      </div>
			    )}
          </div>
        </div>

        {/* Parents/Guardians */}
        <div className="mb-4">
          <div className="text-lg font-semibold mb-1">Parents/Guardians</div>
          {student.parents && student.parents.length > 0 ? (
            <div className="text-sm">
              {student.parents.map((p) => (
                <div key={p.id} className="mb-2 border-b pb-1">
                  <div><span className="font-medium">{p.relation.charAt(0).toUpperCase() + p.relation.slice(1)}:</span> {p.first_name} {p.last_name}</div>
                  {p.email && <div><span className="font-medium">Email:</span> {p.email}</div>}
                  {p.phone && <div><span className="font-medium">Phone:</span> {p.phone}</div>}
                </div>
              ))}
            </div>
          ) : <div className="text-xs text-gray-400">No parent/guardian info</div>}
        </div>

        {/* Referral Information */}
        <div className="mb-4">
          <div className="text-lg font-semibold mb-1">Referral Information</div>
          <div className="text-sm">
            <div><span className="font-medium">Referring Agent:</span> {student.referring_agent || '-'}</div>
            <div><span className="font-medium">Unit:</span> {student.referring_agent_unit || '-'}</div>
            <div><span className="font-medium">Unit ID:</span> {student.referring_agent_unit_id || '-'}</div>
          </div>
        </div>

        {/* Service Status */}
        <div className="mb-4">
          <div className="text-lg font-semibold mb-1">Service Status</div>
          <div className="text-sm">
            <div>
              <span className="font-medium">Status:</span> {student.is_active ? 'Active' : 'Inactive'}
            </div>
            <div>
              <span className="font-medium">Start of Service Date:</span> {formatDate(student.service_start_date)}
            </div>
            <div>
              <span className="font-medium">End of Service Date:</span> {student.service_end_date ? formatDate(student.service_end_date) : 'No end date set'}
            </div>
          </div>
        </div>

        {/* Development Goals & Notes */}
        <div className="mb-2">
          <div className="text-lg font-semibold mb-1">Development Goals & Notes</div>
          <div className="text-sm">
<div>
  <span className="font-medium">Intake Development Goals:</span>
  <span className="whitespace-pre-line">{student.intake_goals || '-'}</span>
</div>
<div>
  <span className="font-medium">Additional Notes:</span>
  <span className="whitespace-pre-line">{student.additional_notes || '-'}</span>
</div>
<div>
  <span className="font-medium">Parent Concerns:</span>
  <span className="whitespace-pre-line">{student.parent_concerns || '-'}</span>
</div>
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default StudentDetailsModal;

